module.exports = __webpack_public_path__ + "img/device-Information_3_v1.0e777247.png";